<template>
    <template v-for="item in menuRender" :key="item.props.key">
        <component :is="item.type" v-bind="item.props">
            <template #title v-if="item.type.name == 'ASubMenu'">
                {{ title_menu(item) }}
            </template>
            <template #default v-if="item.type.name == 'ASubMenu'">
                {{ item.children }}
            </template>
            <template #default v-if="item.type.name == 'AMenuItem'">
                {{ item.props.title }} 
            </template>
        </component>
    </template>
</template>
<!-- <template>
    <a-menu mode="inline">
      <template v-for="item in menuRender" :key="item.props.key">
        <component :is="item.type" v-bind="item.props">
          <template v-for="child in item.children.default()" :key="child.props.key">
            <component :is="child.type" v-bind="child.props">
              {{ child.children.default() }}
            </component>
          </template>
          <template #title>
            {{ item.children.title() }}
          </template>
        </component>
      </template>
    </a-menu>
  </template>   -->
<script>
import { h }  from 'vue';
import { Menu } from 'ant-design-vue';
import { myMenu, iconsLoader, constructMenu, convertirMenu } from './menu_items/menu_constructor'
import { itemConstruccion } from './menu_items/menu_construccion'
export default {
    components: {
      AMenu: Menu
    },
    setup() {
        const menuRender = convertirMenu(itemConstruccion);
        const title_menu = (item) => {
            if (item.type.name == 'AMenuItem') {
                return item.props.title
            }
            if (item.type.name == 'ASubMenu') {
                return item.children.title()
            }
        }
        return {
            menuRender, title_menu
        };
    },
  };
  </script>